import * as Sentry from '@sentry/vue'
import router from '@/core/config/router.installer'
import { PRIORITIES } from '@/core/constants/installation-priorities.constant'
import { useErrorHandling } from '@/shared/composables/error-handling.composable'

export const priority = PRIORITIES.SENTRY

let isSentryInitialized = false

export function install({ app }) {
  if (isSentryInitialized) {
    return
  }

  const { handleError } = useErrorHandling()

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: `dss-frontend@${import.meta.env.VITE_APP_VERSION}`,
    environment: import.meta.env.VITE_SENTRY_ENV,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    beforeSend(event) {
      if (event.exception && event.exception.values) {
        const error = event.exception.values[0]

        if (error.value && error.value.isOperational) {
          return null
        }
      }
      return event
    },
    tracesSampleRate: import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE,
    replaysSessionSampleRate: import.meta.env.VITE_SENTRY_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_ERROR_SAMPLE_RATE,
  })

  isSentryInitialized = true

  app.config.errorHandler = (error, instance, info) => {
    handleError(error, instance?.$options.name || 'Unknown', info)
  }
}
